export enum BookingStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED'
}
